/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clock': {
    width: 22,
    height: 18,
    viewBox: '0 0 22 18',
    data: '<path pid="0" d="M2.6 3.104l8.4 6.6 9-6.6m-12 6.5l-5.4 5.5m16.8-.5l-6-5.5m-9.6 6.992a2.4 2.4 0 01-2.4-2.4V4.304a2.4 2.4 0 012.4-2.4h14.4a2.4 2.4 0 012.4 2.4v9.392a2.4 2.4 0 01-2.4 2.4H3.8z" _stroke="#5B6881" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/clock.js